import React, { useState } from 'react';
import { getByNumero } from '../db';
import '../styles/index.scss';


// ── Configuración de estados ──────────────────────────────────
const STATUSES = [
  { key: 'Producción',            icon: '⏳', color: '#94a3b8', bg: '#f1f5f9' },
  { key: 'En Puerto Origen',      icon: '🏭', color: '#f59e0b', bg: '#fef3c7' },
  { key: 'En tránsito',           icon: '🚢', color: '#0057ff', bg: '#e8f0ff' },
  { key: 'En alta mar',           icon: '🌊', color: '#0ea5e9', bg: '#e0f2fe' },
  { key: 'Fondeo Puerto Quetzal', icon: '🏗️', color: '#8b5cf6', bg: '#ede9fe' },
  { key: 'En aduana',             icon: '🛃', color: '#f97316', bg: '#ffedd5' },
  { key: 'Selectivo',             icon: '✅', color: '#00b894', bg: '#e6faf6' },
  { key: 'En Bodega',             icon: '📦', color: '#00b894', bg: '#e6faf6' },
  { key: 'Entregado',             icon: '🚚', color: '#043461', bg: '#afe0f3' },
];

const STATUS_MAP = Object.fromEntries(STATUSES.map((s, i) => [s.key, { ...s, step: i }]));

function fmtDate(str) {
  if (!str) return '—';
  const d = new Date(str + 'T12:00:00');
  return d.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
}

function Card({ children, style }) {
  return (
    <div style={{
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--r)',
      boxShadow: 'var(--shadow)',
      ...style,
    }}>{children}</div>
  );
}

function InfoField({ icon, label, value, mono }) {
  return (
    <div style={{
      padding: '14px 18px',
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--r-sm)',
    }}>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 5, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 5 }}>
        <span>{icon}</span> {label}
      </div>
      <div style={{
        fontWeight: 500,
        fontSize: mono ? 12 : 14,
        fontFamily: mono ? 'var(--mono)' : 'var(--font)',
        color: value === '—' ? 'var(--text-muted)' : 'var(--text)',
        letterSpacing: mono ? 0.3 : 0,
      }}>{value || '—'}</div>
    </div>
  );
}

export default function TrackingPublico() {
  const [input, setInput] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [mensaje, setMensaje] = useState('');

const buscar = async (e) => {
  e?.preventDefault();
  const val = input.trim().toUpperCase();
  if (!val) return;
  setLoading(true);
  setError('');
  setMensaje('');
  setResult(null);
  try {
    const data = await getByNumero(val);
    if (!data) {
      const numero = Number(val);
      if (!isNaN(numero)) {
        if (numero < 184) {
          setMensaje('entregada');
        } else if (numero > 199) {
          setMensaje('futura');
        } else {
          setError('No se encontró ninguna importación con ese número.');
        }
      } else {
        setError('No se encontró ninguna importación con ese número.');
      }
    } else {
      setResult(data);
    }
  } catch (err) {
    setError('Error al conectar. Intenta nuevamente.');
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  const cfg = result ? (STATUS_MAP[result.status] || STATUS_MAP['Pendiente']) : null;
  const currentStep = cfg?.step ?? -1;

  return (
    <main style={{ minHeight: 'calc(100vh - 60px)', padding: '0 0 60px' }}>

      {/* Hero banner */}
      <div style={{
        background: 'var(--navy)',
        padding: '52px 24px 64px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Decorative wave lines */}
        <svg style={{ position: 'absolute', bottom: 0, left: 0, right: 0, opacity: 0.08 }}
          viewBox="0 0 1440 80" preserveAspectRatio="none" height="80">
          <path d="M0,40 C180,70 360,10 540,40 C720,70 900,10 1080,40 C1260,70 1440,20 1440,40 L1440,80 L0,80 Z" fill="white"/>
        </svg>

        <div className='formaDiv'>
          <div className='tituloPortal'>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--celesteNeon)', display: 'inline-block', animation: 'pulse 2s infinite' }} />
             PORTAL DE TRACKING EN TIEMPO REAL
          </div>
          <style>{`
            @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }
            @keyframes slideUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
          `}</style>

          <h1 style={{
            fontSize: 'clamp(28px, 5vw, 44px)',
            fontWeight: 800,
            color: '#fff',
            letterSpacing: '-1px',
            lineHeight: 1.1,
            marginBottom: 14,
          }}>
            Rastrea tu envío<br />
            <span className='text-neon-celeste'>en tiempo real</span>
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 15, marginBottom: 36 }}>
            Ingresa tu número de importación para ver el estado actualizado de tu importación
          </p>

          {/* Search box */}
          <form onSubmit={buscar} style={{ display: 'flex', gap: 10, maxWidth: 480, margin: '0 auto' }}>
            <input
              value={input}
              onChange={e => setInput(e.target.value)}
              placeholder="Ej: 194"
              style={{
                flex: 1, padding: '14px 18px',
                background: 'rgba(255,255,255,0.08)',
                border: '1.5px solid rgba(255,255,255,0.15)',
                borderRadius: 'var(--r-sm)',
                color: '#fff', fontSize: 15,
                fontFamily: 'var(--mono)', letterSpacing: 1,
                outline: 'none',
                transition: 'border-color 0.2s',
              }}
              onFocus={e => e.target.style.borderColor = '#ffffff'}
              onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'}
            />
            <button className='btn-buscar' type="submit" disabled={loading} style={{
              background: loading ? '#2aace9' : '#ffffff',
              
            }}>
              {loading ? '...' : 'Buscar'}
            </button>
          </form>
        </div>
      </div>

      {/* Error */}
      {error && (
        <div style={{ maxWidth: 700, margin: '24px auto 0', padding: '0 24px' }}>
          <div style={{
            padding: '14px 18px',
            background: 'var(--red-lt)',
            border: '1px solid #fca5a5',
            borderRadius: 'var(--r-sm)',
            color: 'var(--red)',
            fontSize: 14,
            display: 'flex', alignItems: 'center', gap: 10,
          }}>
            <span style={{ fontSize: 18 }}>⚠️</span> {error}
          </div>
        </div>

      )}

      {mensaje === 'entregada' && (
  <div style={{
    marginTop: 24, padding: '20px 24px',
    background: '#f0fdf4',
    border: '1px solid #86efac',
    borderRadius: 'var(--r)',
    textAlign: 'center',
  }}>
    <div style={{ fontSize: 32, marginBottom: 8 }}>🎉</div>
    <p style={{ fontWeight: 700, fontSize: 15, color: '#166534', marginBottom: 4 }}>
      ¡Tu mercancía ya está en Guatemala!
    </p>
    <p style={{ fontSize: 13, color: '#15803d' }}>
      Esta importación fue entregada exitosamente. Si tienes alguna duda sobre tu carga, escríbenos.
    </p>
    
      
  </div>
  )}

      {mensaje === 'futura' && (
        <div style={{
          marginTop: 24, padding: '20px 24px',
          background: '#fffbeb',
          border: '1px solid #fcd34d',
          borderRadius: 'var(--r)',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>🚀</div>
          <p style={{ fontWeight: 700, fontSize: 15, color: '#92400e', marginBottom: 4 }}>
            ¡Esa importación aún no existe... pero podría ser tuya!
          </p>
          <p style={{ fontSize: 13, color: '#b45309' }}>
            Todavía no hemos generado ese número. Si estás interesado en importar con nosotros, escríbenos y con gusto te asesoramos.
          </p>
          
            <a href="https://wa.me/50256722080?text=Hola%2C%20me%20interesa%20importar%20con%20SoloGT"
            target="_blank" rel="noreferrer"
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              marginTop: 14, padding: '9px 20px',
              background: '#25D366', color: '#fff',
              borderRadius: 100, fontSize: 13, fontWeight: 700,
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
            </svg>
            Quiero importar con SoloGT
          </a>
        </div>
      )}

      

      {/* Result */}
      {result && (
        <div style={{ maxWidth: 760, margin: '28px auto 0', padding: '0 24px', animation: 'slideUp 0.4s ease' }}>

          {/* Status header */}
          <Card style={{ padding: '24px 28px', marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
            <div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)', fontFamily: 'var(--mono)', marginBottom: 6, letterSpacing: 0.5 }}>NÚMERO DE IMPORTACIÓN</div>
              <div style={{ fontFamily: 'var(--mono)', fontSize: 24, fontWeight: 500, color: 'var(--navy)', letterSpacing: 1 }}>
                {result.numeroImportacion}
              </div>
            </div>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 10,
              background: cfg.bg,
              border: `1.5px solid ${cfg.color}40`,
              borderRadius: 100, padding: '10px 20px',
            }}>
              <span style={{ fontSize: 22 }}>{cfg.icon}</span>
              <span style={{ fontWeight: 700, color: cfg.color, fontSize: 15 }}>{result.status}</span>
            </div>
          </Card>

          {/* Progress stepper */}
          <Card style={{ padding: '24px 28px', marginBottom: 16 }}>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 600, marginBottom: 22, letterSpacing: 0.5 }}>PROGRESO DEL ENVÍO</div>

            {/* Desktop stepper */}
            <div style={{ overflowX: 'auto', paddingBottom: 8 }}>
              <div style={{ position: 'relative', minWidth: 600 }}>
                {/* Background line */}
                <div style={{ position: 'absolute', top: 14, left: '3.5%', right: '3.5%', height: 2, background: 'var(--border)' }} />
                {/* Progress line */}
                <div style={{
                  position: 'absolute', top: 14, left: '3.5%', height: 2,
                  width: `${(currentStep / (STATUSES.length - 1)) * 93}%`,
                  background: `linear-gradient(90deg, #00b894, ${cfg.color})`,
                  transition: 'width 0.8s ease',
                }} />

                <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative' }}>
                  {STATUSES.map((s, i) => {
                    const done = i < currentStep;
                    const active = i === currentStep;
                    return (
                      <div key={s.key} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, flex: 1 }}>
                        <div style={{
                          width: 28, height: 28, borderRadius: '50%', zIndex: 1,
                          background: done ? '#00b894' : active ? cfg.color : 'var(--surface)',
                          border: `2px solid ${done ? '#00b894' : active ? cfg.color : 'var(--border2)'}`,
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          fontSize: active ? 14 : 11,
                          boxShadow: active ? `0 0 0 4px ${cfg.color}25` : 'none',
                          transition: 'all 0.3s',
                        }}>
                          {done ? <span style={{ color: '#fff', fontWeight: 700, fontSize: 11 }}>✓</span>
                                : active ? s.icon
                                : <span style={{ width: 7, height: 7, borderRadius: '50%', background: 'var(--border2)', display: 'block' }} />}
                        </div>
                        <span style={{
                          fontSize: 10, fontWeight: active ? 700 : 400,
                          color: active ? cfg.color : done ? 'var(--text-mid)' : 'var(--text-muted)',
                          textAlign: 'center', lineHeight: 1.3, maxWidth: 56,
                        }}>{s.key}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </Card>

          {/* Info grid */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 10, marginBottom: 10 }}>
            <InfoField icon="📤" label="Fecha ETD (Salida)" value={fmtDate(result.fechaEtd)} />
            <InfoField icon="📥" label="Fecha ETA (Llegada Estimada)" value={fmtDate(result.fechaEta)} />
            <InfoField icon="📄" label="# BL" value={result.bl} mono />
            <InfoField icon="📦" label="# Contenedor" value={result.contenedor} mono />
            <InfoField icon="🚢" label="Nombre del Barco" value={result.nombreBarco} />
            <InfoField icon="🏢" label="Naviera" value={result.naviera} />
          </div>

          {/* Posición */}
          {result.posicion && (
            <div style={{
              background: 'var(--surface)',
              border: '1px solid var(--border)',
              borderRadius: 'var(--r-sm)',
              padding: '14px 18px',
              marginBottom: 10,
              display: 'flex', alignItems: 'flex-start', gap: 12,
            }}>
              <span style={{ fontSize: 20 }}>📍</span>
              <div>
                <div style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 500, marginBottom: 4 }}>Comentarios:</div>
                <div style={{ fontSize: 14,  whiteSpace: 'pre-line' }}>{result.posicion}</div>
              </div>
            </div>
          )}

          {/* Footer timestamp */}
          <div style={{ textAlign: 'right', padding: '4px 4px 0', fontSize: 11, color: 'var(--text-muted)', fontFamily: 'var(--mono)' }}>
            Última actualización:{' '}
            {result.updatedAt?.toDate
              ? result.updatedAt.toDate().toLocaleString('es-ES')
              : '—'}
          </div>
        </div>
      )}

       <footer style={{
        marginTop: 5,
        background: 'var(--navy)',
        padding: '40px 24px',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 600, margin: '0 auto' }}>

          {/* Logo / nombre */}
          <div style={{ fontWeight: 800, fontSize: 18, color: '#fff', letterSpacing: '-0.3px', marginBottom: 6 }}>
            SoloGT<span style={{ color: 'rgb(29 222 255)' }}> Desde China a Guatemala</span>
          </div>
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13, marginBottom: 28 }}>
            SoloGT - Importaciones en tiempo real
          </p>

          {/* Redes sociales */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: 14, marginBottom: 28 }}>

            {/* Facebook */}
            <a href="https://facebook.com/sologtimportacion" target="_blank" rel="noreferrer"
              style={{ width: 42, height: 42, borderRadius: 10, background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.12)', display: 'flex', alignItems: 'center',
                justifyContent: 'center', transition: 'background 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.16)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
              </svg>
            </a>

            {/* Instagram */}
            <a href="https://instagram.com/sologtimportacion" target="_blank" rel="noreferrer"
              style={{ width: 42, height: 42, borderRadius: 10, background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.12)', display: 'flex', alignItems: 'center',
                justifyContent: 'center', transition: 'background 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.16)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="1" fill="white" stroke="none"/>
              </svg>
            </a>

            {/* TikTok */}
            <a href="https://tiktok.com/@sologtimportacion" target="_blank" rel="noreferrer"
              style={{ width: 42, height: 42, borderRadius: 10, background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.12)', display: 'flex', alignItems: 'center',
                justifyContent: 'center', transition: 'background 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.16)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z"/>
              </svg>
            </a>

            {/* LinkedIn */}
            <a href="https://linkedin.com/company/sologtimportacion" target="_blank" rel="noreferrer"
              style={{ width: 42, height: 42, borderRadius: 10, background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.12)', display: 'flex', alignItems: 'center',
                justifyContent: 'center', transition: 'background 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.16)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/>
                <circle cx="4" cy="4" r="2"/>
              </svg>
            </a>

          </div>

       
          
            <a href="https://wa.me/50256722080?text=Hola%2C%20quisiera%20información%20sobre%20mi%20importación"
            target="_blank"
            rel="noreferrer"
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 10,
              padding: '13px 28px',
              background: '#25D366',
              color: '#fff',
              borderRadius: 100,
              fontWeight: 700, fontSize: 14,
              boxShadow: '0 4px 20px rgba(37,211,102,0.35)',
              transition: 'transform 0.2s, box-shadow 0.2s',
              marginBottom: 32,
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(37,211,102,0.5)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(37,211,102,0.35)'; }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
            </svg>
            Contáctanos por WhatsApp
          </a>

          {/* Copyright */}
          <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 20, color: 'rgba(255,255,255,0.3)', fontSize: 12 }}>
            © {new Date().getFullYear()} SoloGT Importación · Todos los derechos reservados
          </div>

        </div>
      </footer>
      
    </main>
  );
}
